// frontend/src/utils/apiClient.ts
import axios from 'axios';
import { BACKEND_URL, API_BASE } from '../constants';

// Client axios centralisé pour toutes les requêtes API
const apiClient = axios.create({
  baseURL: `${BACKEND_URL}${API_BASE}`,
  withCredentials: true,
  timeout: 30000
});

// Intercepteur pour la gestion des erreurs
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Rediriger vers la page de login ou effacer les données d'authentification
      localStorage.removeItem('token');
    }
    return Promise.reject(error);
  }
);

export default apiClient;